import { render } from "./Checkout.vue?vue&type=template&id=036ed0c4"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"
script.render = render

export default script